<div class="doc" [ngStyle]="{'height': depuisPlanning ? '100%' : '500px'}">
    <div class="col-sm-12 header">
      <h2 class="col-sm-8 pull-left" style="padding:0px; margin: 0;">
        <span> Liste des documents </span>
      </h2>
      <div  class="text-right col-sm-4" style="padding: 0;" *ngIf="depuisPlanning">
          <!--button type="button" class=" btn-valider" (click)="valide()"> Valider </button-->
          <button type="button" class=" btn-close" (click)="valide()" [ngClass]="{'disabledbutton': clickFermer}"> Fermer </button>
        </div>
    </div>
    <div class="col-sm-12 tab" [ngStyle]="{'height': depuisPlanning ? 'auto' : '430px', 'max-height': depuisPlanning ? 'calc(100% - 90px)' : 'none'}">
      <ngx-datatable style="height: 100%" class="material document" [rows]="data" [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0"
        [rowHeight]="40" [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de document à afficher'}"
        [loadingIndicator]="loadingIndicator" (activate)="onActivate($event)">
        <ngx-datatable-column name="Description">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Description </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="row.id">
              {{value}}
            </div>
            <div *ngIf="!row.id">
              <input type="text" class="form-control" [(ngModel)]="row.description">
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="NomFichier" prop="nomFichier">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn" let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Fichier </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <div *ngIf="row.id">
              {{value}}
            </div>
            <div *ngIf="!row.id">
                <input class="hide" id="input-file-id{{rowIndex}}" (change)="getNameFile($event, row)" multiple type="file"  accept="{{ common.extFichierImgEtTexte }}"  />
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="row.nomFichier" readonly>
                  <label class="input-group-addon" for="input-file-id{{rowIndex}}"><i class="fa fa-upload"></i> Parcourir </label>
                </div>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column  *ngIf="!common.isHisto" [width]="70" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <button class="btn-detail" (click)="deleteLigne(row)" *ngIf="!row.isdemande">
              <i class="fa fa-trash"></i>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
    
    
    <div class="col-sm-12"  style="margin-top: 15px; padding: 0px">
      <div class="col-sm-6" style="padding: 0;">
        <button class="btn-add" (click)="addLigne()" *ngIf="!common.isHisto" >
          <i class="fa fa-plus"></i>
        </button>
        <span *ngIf="!common.isHisto" > Ajouter un document </span>
      </div>
      <div  class="text-right col-sm-6" style="padding: 0;" *ngIf="!depuisPlanning">
        <button *ngIf="data.length" type="button" style="width: 184px; margin-right: 5px"
            class="btn-close btn-validerMdl" (click)="downloadAll()"> Tout télécharger </button>
        <button type="button" class=" btn-close" (click)="valide()" [ngClass]="{'disabledbutton': clickFermer}"> Fermer </button>
      </div>
      
    </div>
  </div>
  
  <ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer </button>
        </div>
    </div>
  </ng-template>